import React from 'react';
import Title from '../../../../../@casino/ui/title';
import TableCasino from '../../components/table';
import { useSelector, useDispatch } from 'react-redux';
import Dialog from '@material-ui/core/Dialog';
import { setPostCreateOrganization } from '../../store/thunk/setPostCreateOrganization';
import { setGetListOrganization } from '../../store/thunk/setGetListOrganization';
import ModalBalance from '../../components/modalBalance';

const ObjectOrganization = () => {
    const dispatch = useDispatch();
    const [search, setSearch] = React.useState('');
    const [openModal, setOpenModal] = React.useState(false);
    const [updateBalance, handleUpdateBalance] = React.useState(false);
    const [selectedId, handleSelectedId] = React.useState(0);
    const [hasAdd, handleAdd] = React.useState(true);
    const [name, setName] = React.useState('');
    
    React.useEffect(() => {
        dispatch(setGetListOrganization({
            search: ''
        }));
    }, [])

    const columns = [
        { id: 'id', label: 'ID'},
        { id: 'mirror', label: 'Организация'},
        { id: 'grgreen', label: 'GR-GREEN'},
        { id: 'gryellow', label: 'GR-YELLOW'},
        { id: 'gr02green', label: 'GR02-GREEN'},
    ];

    const getRows = (search) => {
        return search.map((item) => {
            return {
                id: item.id,
                mirror: item.mirror,
                grgreen: item.grgreen,
                gryellow: item.gryellow,
                gr02green: item.gr02green
            }
        })
    } 
    const list = useSelector((state) => state.objectOrganization.list);
    const rows = React.useMemo(() => getRows(list), [list]);

    return (
        <div style={{padding: '0 20px'}}>
            <Title 
                label="Объекты организации" 
                labelBtn="Добавить"
                button={() => setOpenModal(true)}    
            />
            <div style={{
                 padding: 0, 
                 background: '#1b2039', 
                 borderRadius: 8, 
                 marginBottom: 12,
            }}>
                <label htmlFor="search">
                    <input 
                        type="text" 
                        name="search" 
                        id="search" 
                        value={search} 
                        onChange={(v) => {
                            dispatch(setGetListOrganization({
                                search: v.target.value
                            }));
                            setSearch(v.target.value)
                        }} 
                        style={{
                            padding: 10,
                            background: '#141b33',
                            paddingLeft: 10,
                            border: '1px solid #141b33',
                            color: '#fff',
                            outline: 'none',
                            margin: 10,
                            width: '97.3%'
                        }}
                        placeholder="Поиск организации"
                    />
                </label>
            </div>
            <div style={{
                padding: 10, 
                background: '#1b2039', 
                borderRadius: 8, 
                marginBottom: 12,
            }}>
                <TableCasino
                    width={1300}
                    columns={columns}
                    rows={rows}
                    handleUpdateBalance={handleUpdateBalance}
                    handleSelectedId={handleSelectedId}
                    handleAdd={handleAdd}
                />
            </div>
            <Dialog onClose={() => setOpenModal(false)} open={openModal}>
                <div style={{padding: 20}}>
                    <h3 style={{padding: 0, margin: 0, fontFamily: 'Montserrat, sans-serif', fontSize: 18}}>Добавление новой организации</h3>
                    <label htmlFor="" style={{display: 'flex', marginTop: 8}}>
                        <input 
                            type="text"
                            style={{
                                margin: 0,
                                border: '1px solid #e5e5e5',
                                borderRadius: 4,
                                width: '100%',
                                height: 30,
                                padding: '5px 10px',
                            }}
                            value={name}
                            placeholder="Название"
                            onChange={(v) => setName(v.target.value)}
                        />
                    </label>
                    <div style={{display: 'flex', width: '100%', marginTop: 8}}>
                        <span
                            style={{
                                color: 'rgb(20, 27, 51)',
                                cursor: 'pointer',
                                padding: 10,
                                background: 'rgb(255, 195, 36)',
                                borderRadius: 4,
                                width: '100%',
                                display: 'flex',
                                justifyContent: 'center'
                            }}
                            onClick={() => {
                                dispatch(setPostCreateOrganization({name}))
                                setOpenModal(false)
                            }}
                        >Cоздать</span>
                    </div>
                </div>
            </Dialog>
            <ModalBalance 
                handleUpdateBalance={handleUpdateBalance} 
                updateBalance={updateBalance} 
                handleSelectedId={handleSelectedId}
                selectedId={selectedId}
                hasAdd={hasAdd}
                handleAdd={handleAdd}
            />
        </div>
    )
}

export default ObjectOrganization;